import {
  LOADING_USERS,
  GET_USERS,
  UPDATE_USER,
  DELETE_USER,
  INVITE_USER,
  GET_USER_STEPS,
} from '../actions/types';

const initialState = {
  loadingUsers: false,
  users: [],
  updatingUser: false,
  deletingUser: false,
  loadingInviteUser: false,
  loadingUserSteps: false,
  userSteps: [],
  resendingInvitation: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case LOADING_USERS:
      return {
        ...state,
        [payload.field]: payload.value,
      };
    case GET_USERS:
      return {
        ...state,
        loadingUsers: false,
        users: payload,
      };
    case UPDATE_USER:
      return {
        ...state,
        users: state.users.map((user) =>
          user.id === payload.id ? payload : user
        ),
      };
    case DELETE_USER:
      return {
        ...state,
        deletingUser: false,
        users: state.users.filter((user) => user.id !== payload),
      };
    case INVITE_USER:
      return {
        ...state,
        loadingInviteUser: false,
        users: [...state.users, payload],
      };
    case GET_USER_STEPS:
      return {
        ...state,
        loadingUserSteps: false,
        userSteps: payload,
      };
    default:
      return state;
  }
};
